import { useMutation } from '@tanstack/react-query';
import productService from 'v2/services/product';

import type { UseMutationOptions } from '@tanstack/react-query';

type Payload = {
  productId: number;
  offerId: number;
};

export function useDesactiveProductOffer(options: UseMutationOptions<void, unknown, Payload> = {}) {
  return useMutation({
    mutationFn: async ({ productId, offerId }: Payload) => productService.desactivateOffer(productId, offerId),
    ...options,
  });
}
